import React from "react";
import Joi from "joi-browser";
import Form from "./common/form";
import { login, isLoggedIn } from "../store/auth";

import { Redirect } from "react-router-dom";
import { connect } from "react-redux";

import _ from "underscore";

const USER_NAME = "Username";
const PASSWORD = "Password";
const LOGIN = "Login";

class LoginForm extends Form {
  state = {
    data: { userName: "", password: "" },
    errors: {},
  };

  schema = {
    userName: Joi.string().required().label(USER_NAME),
    password: Joi.string().required().label(PASSWORD),
  };

  doSubmit = async () => {
    try {
      const { data } = this.state;
      await this.props.login({
        userName: data.userName,
        password: data.password,
      });

      const { state } = this.props.location;
      window.location = state ? state.from.pathname : "/";
    } catch (e) {
      if (e.response && e.response.status === 400) {
        const errors = { ...this.state.errors };
        errors.userName = e.response.data;
        this.setState({ errors });
      }
    }
  };

  render() {
    if (isLoggedIn()) return <Redirect to="/" />;

    return (
      
      <div className="d-flex justify-content-center">
        <div className="p-4 rounded shadow" style={{marginTop: 90}}>
          <h1>{LOGIN}</h1>
          <form onSubmit={this.handleSubmit}>
            {this.renderInput("userName", USER_NAME, false)}
            {this.renderInput("password", PASSWORD, false, "password")}
            {this.renderButton(LOGIN, false)}
          </form>
        </div>
      </div>
    
    );
  }
}

const mapStateToProps = (state) => ({
  // currentUser: state.auth.currentUser,
  // token: state.auth.token,
});

const mapDispatchToProps = (dispatch) => ({
  login: ({ userName, password }) => dispatch(login({ userName, password })),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
